<template>
  <div>
    <d-input-group>
      <v-input
        v-model="form.driving_licence_number"
        name="driving_licence_number"
        class="column"
      />
      <v-input-date
        v-model="form.driving_licence_expiry_date"
        name="driving_licence_expiry_date"
        class="column"
      />
      <v-input-media
        v-model="form.driving_licence_picture_upload"
        name="driving_licence_picture_upload"
        :max="1"
        :mimes="['image/jpeg', 'image/png', 'image/svg+xml', 'image/webp', 'image/gif', 'application/pdf']"
        :existing-files="user ? user.driving_licence_picture : []"
        class="column is-full"
      />
    </d-input-group>
  </div>
</template>

<script>
import Fieldset from "@/plugins/form/Fieldset";

export default {
  extends: Fieldset,
  props: {
    user: {
      default: null,
      type: Object
    }
  }
};

</script>
